// src/api/apiPaxTypes.js
import axios from "../utils/axios";

/// Get Pax Types
export const getAllPaxTypes = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("pax-types", { params });
    return data;
};

/// Get Pax Type
export const getPaxType = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`pax-types/${id}`);
    return data;
};

/// Create Pax Type
export const createPaxType = async (req) => {
    try {
        const { data } = await axios.post("pax-types", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createPaxType error:", error);
        throw error;
    }
};

/// Update Pax Type
export const updatePaxType = async (req, id) => {
    try {
        const { data } = await axios.put(`pax-types/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updatePaxType error:", error);
        throw error;
    }
};

/// Delete Pax Type
export const deletePaxType = async (id) => {
    try {
        const { data } = await axios.delete(`pax-types/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deletePaxType error:", error);
        throw error;
    }
};

/// Delete All Pax Types
export const deleteAllPaxTypes = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "pax-types/mass-destroy",
            { data: { items: ids } },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllPaxTypes error:", error);
        throw error;
    }
};

/// Restore Pax Type
export const restorePaxType = async (id) => {
    try {
        const { data } = await axios.post(`pax-types/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restorePaxType error:", error);
        throw error;
    }
};

/// Restore multiple Pax Types
export const restoreAllPaxTypes = async (ids = []) => {
    try {
        const { data } = await axios.post(
            "pax-types/mass-restore",
            { items: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllPaxTypes error:", error);
        throw error;
    }
};

/// Force Delete Pax Type
export const forceDeletePaxType = async (id) => {
    try {
        const { data } = await axios.delete(`pax-types/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeletePaxType error:", error);
        throw error;
    }
};

/// Force Delete multiple Pax Types
export const forceDeleteAllPaxTypes = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "pax-types/mass-force-delete",
            { data: { items: ids } },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllPaxTypes error:", error);
        throw error;
    }
};

/// Get Pax Types for Select Dropdown (optional, for future use)
export const getPaxTypesForSelect = async () => {
    try {
        const { data } = await axios.get("pax-types/for-select");
        return data;
    } catch (error) {
        console.error("getPaxTypesForSelect error:", error);
        throw error;
    }
};